import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

const LeadForm = ({ modal, close }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(false);

  return (
    <div
      className={`${
        modal
          ? "fixed inset-0 bg-black/60 flex items-center justify-center z-50"
          : ""
      }`}
    >
      <div className="bg-white rounded-xl w-[90%] max-w-md">
        <div className="bg-[#090c6a] p-2 rounded-t-xl">
          {modal && (
            <button
              onClick={close}
              className="float-right text-white text-xl font-bold mr-1"
            >
              ✕
            </button>
          )}

          <h2 className="text-xl text-white text-center font-semibold">
            Get Instant Callback
          </h2>
        </div>

        <Formik
          initialValues={{ name: "", phone: "" }}
          validationSchema={Yup.object({
            name: Yup.string().required("Name required"),
            phone: Yup.string()
              .matches(/^[0-9]{10}$/, "Invalid number")
              .required("Phone required"),
          })}
          onSubmit={async (values, { resetForm }) => {
            try {
              setLoading(true);
              setFormError(false);

              const formData = new FormData();
              formData.append("Name", values.name);
              formData.append("Phone", values.phone);

              const crmData = {
                name: values.name,
                phone: values.phone,
                listId: "69a52513ffd8964e24b66924",
                redirect: "",
              };

              const [googleResponse, crmResponse] = await Promise.all([
                fetch(
                  "https://script.google.com/macros/s/AKfycbyFtBNtJj1cXCM1UCJGGTg_0dKXxgQXg151DOXBtNeB7InBKVonL_cQnk2x-FgWUDr97g/exec",
                  {
                    method: "POST",
                    body: formData,
                  },
                ),
                fetch(
                  "https://enterprise.godial.cc/meta/api/externals/contact/add?access_token=nbcLc99ivtoh5FO8xqGEOZEW6ddcb4szdtvHdVNCeTh980VQNehbfScBK0MvbQTb",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(crmData),
                  },
                ),
              ]);

              if (!googleResponse.ok || !crmResponse.ok) {
                throw new Error("Submission failed");
              }

              resetForm();
              modal && close();
              navigate("/thank-you");
            } catch (error) {
              console.error("Lead submit error:", error);
              setFormError(true);
            } finally {
              setLoading(false);
            }
          }}
        >
          <Form className="space-y-4 p-6">
            <div className="flex justify-center">
              <img
                src="/Images/LOGO.jpg"
                alt="Kamdhenu Vashi"
                className="w-40 h-12"
              />
            </div>

            <Field
              name="name"
              placeholder="Full Name"
              className="w-full border p-3 rounded-lg"
            />
            <ErrorMessage
              name="name"
              component="div"
              className="text-red-500 text-sm"
            />

            <Field
              name="phone"
              placeholder="Mobile Number"
              className="w-full border p-3 rounded-lg"
            />
            <ErrorMessage
              name="phone"
              component="div"
              className="text-red-500 text-sm"
            />

            {formError && (
              <div className="text-red-600 text-sm text-center">
                Something went wrong. Please try again.
              </div>
            )}

            <div className="flex items-start gap-2 text-xs text-gray-600">
              <input type="checkbox" className="mt-1" defaultChecked />
              <p>
                I consent to the processing of provided data according to{" "}
                <span
                  className="text-[#090C6A] underline cursor-pointer"
                  onClick={() => {
                    navigate("/policy");
                    window.scrollTo(0, 0);
                  }}
                >
                  Privacy Policy
                </span>{" "}
                | Terms & Conditions.
              </p>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#090c6a] hover:bg-[#1218A6] text-white py-3 rounded-lg disabled:opacity-60"
            >
              {loading ? "Submitting..." : "Submit"}
            </button>

            <h2 className="text-center font-extrabold">Or</h2>
            <a
              href="https://api.whatsapp.com/send?phone=9326959938&text=I am interested in Kamdhenu Conquest, Vashi project and want more information about this project."
              className="flex items-center justify-center gap-1 bg-[linear-gradient(195deg,_#53d161,_#23b73c)] w-full text-white px-6 py-3 rounded-lg"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="/Images/WhatsApp.gif"
                alt="Kamdhenu Conquest contact"
                className="w-6 h-6 invert brightness-200"
              />
              Connect On WhatsApp
            </a>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default LeadForm;
